// helmet.js

import React from 'react';
import { Helmet } from 'react-helmet';

const GlobalHelmet = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://plambech.dev/#organization",
    "name": "Plambech Development",
    "legalName": "Plambech Development",
    "url": "https://plambech.dev/",
    "logo": "https://plambech.dev/logo.png",
    "description": "Plambech Development is a freelance development agency founded by Rasmus Plambech, specializing in WordPress development, marketing, SEO optimization, tracking, and data analysis. With over 11 years of hands-on experience in PHP, WordPress, and front-end development, I excel in transforming complex ideas into elegant digital experiences. Our personalized approach ensures your digital presence is built for growth, security, and success. We offer custom, high-performing websites and tailored digital solutions, combining technical precision with a strategic eye for SEO, data analytics, and cybersecurity. Whether you're looking to build a standout website, need assistance with Salesforce integration, SEO optimization, or help implementing server-side tagging, Plambech Development is here to turn your ideas into impactful digital experiences.",
    "email": "info@rplambech.dk",
    "telephone": "+45-XXX-XXXXX",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rådhusstræde 15",
      "addressLocality": "Copenhagen",
      "postalCode": "1466",
      "addressCountry": "DK"
    },
    "founder": {
      "@type": "Person",
      "@id": "https://plambech.dev/#founder",
      "name": "Rasmus Plambech",
      "jobTitle": "Freelance Web Developer",
      "url": "https://plambech.dev/about",
      "sameAs": [
        "https://www.linkedin.com/in/rasmusplambech/"
      ]
    },
    "sameAs": [
      "https://www.linkedin.com/in/rasmusplambech/"
    ]
  };

  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": "https://plambech.dev/#founder",
    "name": "Rasmus Plambech",
    "jobTitle": "Freelance Web Developer & WordPress Expert",
    "description": "Rasmus Plambech is a seasoned freelance developer with over 11 years of experience specializing in WordPress, PHP, JavaScript, SEO optimization, and custom web development solutions.",
    "url": "https://plambech.dev/",
    "image": "https://plambech.dev/static/media/rasmus-plambech-social-share.85256b37cbf084451757.jpg",
    "email": "info@rplambech.dk",
    "worksFor": {
      "@type": "Organization",
      "name": "Plambech Development",
      "@id": "https://plambech.dev/#organization"
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Copenhagen",
      "addressCountry": "DK"
    },
    "sameAs": [
      "https://www.linkedin.com/in/rasmusplambech/"
    ],
    "knowsAbout": [
      "WordPress Development",
      "PHP Programming",
      "JavaScript",
      "SEO Optimization",
      "Web Development",
      "Digital Marketing",
      "Salesforce Integration",
      "Server-side Tagging"
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://plambech.dev/#website",
    "url": "https://plambech.dev/",
    "name": "Plambech Development",
    "description": "Custom WordPress and PHP development by Rasmus Plambech",
    "publisher": {
      "@id": "https://plambech.dev/#organization"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://plambech.dev/?s={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      {/* Organization Schema */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>

      {/* Person Schema */}
      <script type="application/ld+json">
        {JSON.stringify(personSchema)}
      </script>

      {/* Website Schema */}
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta charSet="UTF-8" />
      <meta name="author" content="Rasmus Plambech" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta name="twitter:label1" content="Written by" />
      <meta name="twitter:data1" content="Rasmus Plambech" />

      {/* Social Media Image Tag with Full URL */}
      <meta property="og:image" content="https://plambech.dev/static/media/rasmus-plambech-social-share.85256b37cbf084451757.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Rasmus Plambech - Freelance Web Developer" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content="https://plambech.dev/static/media/rasmus-plambech-social-share.85256b37cbf084451757.jpg" />
      <meta name="twitter:image:alt" content="Rasmus Plambech - Freelance Web Developer" />

    </Helmet>
  );
};

export default GlobalHelmet;